import { useEffect } from "react";
import { Phone, Mail, MapPin, ShoppingCart, Package, Flower2, Route, Printer, Star } from "lucide-react";

const SERVICES = [
  { icon: ShoppingCart, label: "Drive & courses" },
  { icon: Package, label: "Colis & retraits" },
  { icon: Flower2, label: "Fleurs & cadeaux" },
  { icon: Route, label: "Courses sur mesure" },
];

export default function Flyer() {
  useEffect(() => {
    document.title = "Flyer Angélivraisons — A5 à imprimer";
  }, []);

  return (
    <div className="min-h-screen bg-[#DCE9EF] py-8 print:bg-white print:py-0">
      <style>{`
        @page { size: A5 portrait; margin: 0; }
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; }
        }
      `}</style>

      <div className="no-print mx-auto mb-6 flex max-w-[148mm] items-center justify-between px-4">
        <p className="text-sm text-ink/60">Flyer A5 (148 × 210 mm) — prêt à imprimer</p>
        <button
          onClick={() => window.print()}
          data-testid="flyer-print-button"
          className="flex min-h-[44px] items-center gap-2 rounded-full bg-forest px-5 text-sm font-semibold text-cream transition-colors hover:bg-forest-dark"
        >
          <Printer className="h-4 w-4" /> Imprimer / PDF
        </button>
      </div>

      <div
        className="mx-auto flex flex-col overflow-hidden bg-white shadow-2xl print:shadow-none"
        style={{ width: "148mm", minHeight: "210mm" }}
        data-testid="flyer-a5"
      >
        <div className="bg-forest px-8 pb-7 pt-8 text-center text-cream">
          <img
            src="/logo-512.png"
            alt="Angélivraisons"
            className="mx-auto h-28 w-28 rounded-full object-cover shadow-lg ring-4 ring-cream/25"
          />
          <p className="mt-4 font-serif text-3xl font-semibold tracking-tight">
            Angé<span className="text-terra">livraisons</span>
          </p>
          <p className="mt-1.5 text-sm text-cream/85">
            Livraison de proximité à Illzach & alentours
          </p>
        </div>

        <div className="flex-1 px-8 py-6">
          <p className="text-center font-serif text-lg italic text-ink/80">
            « Vos courses, vos colis, vos fleurs — livrés chez vous, avec le cœur. »
          </p>

          <div className="mt-5 grid grid-cols-2 gap-2.5">
            {SERVICES.map((s) => (
              <div key={s.label} className="flex items-center gap-2.5 rounded-xl bg-cream px-3.5 py-3 ring-1 ring-ink/5">
                <s.icon className="h-5 w-5 shrink-0 text-forest" />
                <span className="text-sm font-semibold text-ink">{s.label}</span>
              </div>
            ))}
          </div>

          <div className="mt-4 flex items-center justify-center gap-2 rounded-xl bg-terra/10 px-4 py-3">
            <Star className="h-4 w-4 fill-terra text-terra" />
            <p className="text-sm font-semibold text-terra-dark">
              De 5 à 15 € selon la distance — notée 5/5 par mes clients
            </p>
          </div>

          <div className="mt-5 text-center">
            <img
              src="/qrcode-angelivraisons.png"
              alt="QR code vers angelivraisons.com"
              className="mx-auto h-44 w-44 rounded-2xl ring-1 ring-ink/10"
            />
            <p className="mt-2 font-serif text-base font-semibold text-forest">Scannez pour réserver en 2 minutes</p>
            <p className="text-sm font-semibold tracking-wide text-terra-dark">angelivraisons.com</p>
          </div>
        </div>

        <div className="bg-cream px-8 py-5 text-center ring-1 ring-ink/5">
          <p className="flex items-center justify-center gap-2 text-base font-bold text-ink">
            <Phone className="h-4 w-4 text-terra" /> 06 73 31 82 36
          </p>
          <p className="mt-1.5 flex items-center justify-center gap-2 text-xs text-ink/60">
            <Mail className="h-3.5 w-3.5" /> angelivraisons@gmail.com
            <span className="text-ink/25">·</span>
            <MapPin className="h-3.5 w-3.5" /> Illzach, rayon 20 km
          </p>
          <p className="mt-1.5 text-xs text-ink/50">
            Lun–Ven : 8h–17h · Sam : 8h–16h · Paiement CB, espèces ou virement
          </p>
          <p className="mt-2 text-[10px] text-ink/35">Angélivraisons — SIRET 130 826 621 00018</p>
        </div>
      </div>
    </div>
  );
}
